function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MEMBERSHIP } from '../../../constants/membership';
import routes from '../../../routes/constants';
import text, { formatCurrency } from '../../../text';
import { isMembershipPriceId, isYearlyMembershipPriceId } from '../../../utilities/membership';
import { getUserPriceId, isUserUnderTrial } from '../../../utilities/user';
import MembershipCard from './MembershipCard';
import MembershipOption from './MembershipOption';
var _obj;
var memberships = (_obj = {}, _define_property(_obj, MEMBERSHIP.MONTHLY.PRICE_ID, {
    priceId: [
        MEMBERSHIP.MONTHLY.PRICE_ID
    ],
    info: [
        {
            firstHeader: text('essentials'),
            primaryText: text('monthlyMembershipRenews')
        },
        {
            secondText: "/".concat(text('month')),
            secondHeader: formatCurrency(90, 'aud', 1, {}, true),
            supplementalText: "*".concat(text('minPriceAmount', {
                amount: formatCurrency(1080, 'aud', 1, {
                    maximumFractionDigits: 0
                }, true)
            }))
        }
    ]
}), _define_property(_obj, MEMBERSHIP.YEARLY.PRICE_ID, {
    priceId: MEMBERSHIP.YEARLY.PRICE_ID,
    info: [
        {
            firstHeader: text('essentials'),
            primaryText: text('annualMembershipRenews')
        },
        {
            secondHeader: formatCurrency(75, 'aud', 1, {}, true),
            secondText: "/".concat(text('monthEquivalent'), "*"),
            supplementalText: "*".concat(text('paidUpfrontAmount', {
                months: 12,
                amount: formatCurrency(900, 'aud', 1, {
                    maximumFractionDigits: 0
                }, true)
            }))
        }
    ]
}), _define_property(_obj, MEMBERSHIP.NO_MEMBERSHIP, {
    priceId: MEMBERSHIP.NO_MEMBERSHIP,
    info: [
        {
            firstHeader: text('noMembership'),
            primaryText: text('noMembershipFeatures')
        }
    ]
}), _obj);
var _obj1;
var membershipOptions = (_obj1 = {}, _define_property(_obj1, MEMBERSHIP.YEARLY.PRICE_ID, {
    label: text('yearlySaveDiscount', {
        discount: 17
    }),
    priceId: MEMBERSHIP.YEARLY.PRICE_ID
}), _define_property(_obj1, MEMBERSHIP.MONTHLY.PRICE_ID, {
    label: text('monthly'),
    priceId: MEMBERSHIP.MONTHLY.PRICE_ID
}), _define_property(_obj1, MEMBERSHIP.NO_MEMBERSHIP, {
    label: text('noThanks'),
    priceId: MEMBERSHIP.NO_MEMBERSHIP
}), _obj1);
var MembershipForm = function(param) {
    var membershipPriceId = param.membershipPriceId, onMembershipChange = param.onMembershipChange, _param_includeNoMembership = param.includeNoMembership, includeNoMembership = _param_includeNoMembership === void 0 ? true : _param_includeNoMembership;
    var currentUser = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile
        };
    }).currentUser;
    var noMembershipOption = membershipOptions[MEMBERSHIP.NO_MEMBERSHIP];
    useEffect(function() {
        if (getUserPriceId(currentUser)) {
            onMembershipChange(isYearlyMembershipPriceId(getUserPriceId(currentUser)) ? MEMBERSHIP.MONTHLY.PRICE_ID : MEMBERSHIP.YEARLY.PRICE_ID);
        }
    }, []);
    var Membership = function() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "MembershipForm-card"
        }, /*#__PURE__*/ React.createElement(MembershipCard, memberships[membershipPriceId]), isMembershipPriceId(membershipPriceId) && /*#__PURE__*/ React.createElement("div", {
            className: "termsAndCond"
        }, /*#__PURE__*/ React.createElement("div", null, "*".concat(text('pricingTax'))), /*#__PURE__*/ React.createElement("a", {
            href: routes.larkiWebsiteUrl.custTermsCond,
            target: "_blank",
            rel: "noreferrer"
        }, text('larkiTermsAndCond'))));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "MembershipForm"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "MembershipForm-options"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "options-label"
    }, "".concat(text('billed'), ":")), [
        membershipOptions[MEMBERSHIP.YEARLY.PRICE_ID],
        membershipOptions[MEMBERSHIP.MONTHLY.PRICE_ID]
    ].filter(function(param) {
        var priceId = param.priceId;
        return priceId !== getUserPriceId(currentUser) || isUserUnderTrial(currentUser);
    }).map(function(param, index) {
        var label = param.label, priceId = param.priceId, extraText = param.extraText;
        return /*#__PURE__*/ React.createElement(MembershipOption, {
            onChange: onMembershipChange,
            key: index,
            label: label,
            priceId: priceId,
            isSelected: membershipPriceId === priceId,
            noMembership: !isMembershipPriceId(priceId),
            extraText: extraText,
            tooltipText: isYearlyMembershipPriceId(priceId) && membershipPriceId !== priceId && isMembershipPriceId(membershipPriceId) ? text('percentageSaving', {
                percentage: 17
            }) : undefined
        });
    }), includeNoMembership ? /*#__PURE__*/ React.createElement(MembershipOption, {
        onChange: onMembershipChange,
        label: noMembershipOption.label,
        priceId: noMembershipOption.priceId,
        isSelected: membershipPriceId === noMembershipOption.priceId,
        noMembership: !isMembershipPriceId(noMembershipOption.priceId)
    }) : null)), /*#__PURE__*/ React.createElement(Membership, null));
};
export default MembershipForm;
